import styled from 'styled-components'

export const PreviewContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
  img {
    height: ${props => props.theme.size.XL};
    width: ${props => props.theme.size.XL};
    object-fit: cover;
  }
`
